export const SITE = {
  nameEn: "LAO HERB",
  tagline: "源自老挝山林的原生态中药材品牌", // 方案文档原文,不得改
  region: "老挝·沙耶武里",
  coords: "LAOS · XAYABOURY",
  hirudinDisclaimer: "本品不能代替药物。具体功能以产品说明书及相关资质为准。",
} as const;
